import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const rows = 47;

const Bracket13: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%'}}>
            <Grid columns="repeat(8, 1fr)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 4' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '6 / 8' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 12' }}>
                        <Game game={games[2]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '15 / 17' }}>
                        <Game game={games[3]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '19 / 21' }}>
                        <Game game={games[4]} topLabel bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '28 / 30' }} align="center" justify="flex-end" pe="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">TOILET BOWL BRACKET</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '37 / 38' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '39 / 41' }}>
                        <Game game={games[9]} topLabel bottomLabel/>
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[5]} topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '7 / 9' }}>
                        <Game game={games[6]} bottomLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '11 / 14' }}>
                        <Game game={games[7]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '16 / 20' }}>
                        <Game game={games[8]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '23 / 28' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '28 / 30' }} bgColor="tertiary200">
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '32 / 34' }}>
                        <Game game={games[12]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '36 / 38' }}>
                        <Game game={games[11]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '40 / 42' }}>
                        <Game game={games[13]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '44 / 46' }}>
                        <Game game={games[10]} topLabel bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 8' }}>
                        <Game game={games[14]} />
                    </Cell>
                    <Cell style={{ gridRow: '13 / 19' }}>
                        <Game game={games[15]} />
                    </Cell>

                    {/* Toilet Bowl */}
                    <Cell style={{ gridRow: '23 / 25' }} bgColor="tertiary200">
                        <Game game={tbGames[1]} bottomLabel topLabel />
                    </Cell>

                    <Cell style={{ gridRow: '25 / 27' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '27 / 29' }} bgColor="tertiary200">
                        <Game game={tbGames[2]} topLabel />
                    </Cell>

                    <Cell style={{ gridRow: '29 / 30' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '33 / 37' }}>
                        <Game game={games[17]}  />
                    </Cell>
                    <Cell style={{ gridRow: '41 / 45' }}>
                        <Game game={games[16]} />
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '5 / 19' }}>
                        <Game game={games[20]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '23 / 24' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '24 / 28' }} bgColor="tertiary200">
                        <Game game={tbGames[3]} />
                    </Cell>
                    <Cell style={{ gridRow: '28 / 30' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '35 / 39' }}>
                        <Game game={games[19]} bottomLabel />
                    </Cell>

                    <Cell style={{ gridRow: '43 / 46' }}>
                        <Game game={games[18]} bottomLabel />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '12 / 13' }}>
                        <ByGame />
                    </Cell>

                    {/* TB Winner */}

                    <Cell style={{ gridRow: '23 / 26' }} bgColor="tertiary200" width="100px"/>
                    <Cell style={{ gridRow: '26 / 27' }} bgColor="tertiary200" width="100px">
                        <ByGame tb color="black" />
                    </Cell>
                    <Cell style={{ gridRow: '27 / 30' }} bgColor="tertiary200" width="100px"/>

                    {/* Losers */}

                    <Cell style={{ gridRow: '37 / 45' }}>
                        <Game game={games[21]} />
                    </Cell>
                </Grid>
                {/* Round 6 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '12 / 13' }}>
                        <ByGame />
                    </Cell>

                    {/* Losers */}
                    <Cell style={{ gridRow: '41 / 47' }}>
                        <Game game={games[22]}
                            bottomLabel
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>
                {/* Round 7 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '12 / 44' }} className={style.lastGame}>
                        <Game game={games[23]}  />
                    </Cell>
                </Grid>
                {/* Round 8 */}
                <Grid columns="1fr 1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '28 / 30' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                    <Cell style={{ gridRow: '30 / 33' }}>
                        <Game game={games[24]} />
                    </Cell>
                </Grid>

                {games[23].winner && games[23].team2.id === games[23].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '20 / 36' }} width="260px">
                            <Game game={games[24]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '31 / 33' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket13;
